import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";

function ErrorBoundary() {
  let error = useRouteError();

  const errorMessage = error?.message || "Something went wrong!";
  const status = error?.status || "Unknown";

  // Uncaught ReferenceError: path is not defined
  return <div>Dang!</div>;
}

export default ErrorBoundary;
